import dayjs from "dayjs";
import { IUser } from "../../../types/User";
import { useTranslation } from "react-i18next";

const ImamBasicInfo = ({ user, dataSources }: { user: IUser, dataSources?: any[] }) => {
    const { t } = useTranslation();
    
    return (
        <div className="space-y-3">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4">
                <div>
                    <div className="text-gray-500">
                        {t("Name")}
                    </div>
                    <div>{user.name}</div>
                </div>
                <div>
                    <div className="text-gray-500">{t("Login Name")}</div>
                    <div>
                        {t(user.loginName)}
                    </div>
                </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4">
                <div>
                    <div className="text-gray-500">{t("Mobile No.")}</div>
                    <div>{user.mobileNo || "-"}</div>
                </div>
                <div>
                    <div className="text-gray-500">{t("Email")}</div>
                    <div>{user.email || "-"}</div>
                </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4">
                <div>
                    <div className="text-gray-500">
                        {t("Gender")}
                    </div>
                    <div>{user.profileData?.gender || "-"}</div>
                </div>
                <div>
                    <div className="text-gray-500">
                        {t("Date of Birth")}
                    </div>
                    <div>{user.profileData?.dateOfBirth ? dayjs(user.profileData.dateOfBirth).format("DD MMM YYYY") : "-"}</div>
                </div>
            </div>
        </div>
    );
};

export default ImamBasicInfo;
